export const esData = `
<div class="paragraph">
<div class="title">¿Qué debo hacer antes de enviar mi dispositivo antiguo?</div>
<div class="text-box">
  <div class="text">El servicio está disponible solo para personas <b>mayores de 18 años</b>, residentes
  en <b>la España peninsular</b>. Actualmente no está disponible en Islas Canarias ni
  Baleares.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Qué debo hacer antes de enviar mi dispositivo antiguo?</div>
<div class="text-box">
  <div class="text">Antes de enviar tu dispositivo:</div>
  <div class="text">• Borra todos los datos personales y elimina cualquier PIN, contraseña o patrón de desbloqueo</div>
  <div class="text">• Realiza un restablecimiento completo de fábrica</div>
  <div class="text">• En iPhone: desconecta tu cuenta de iCloud desactivando "Buscar mi iPhone"</div>
  <div class="text">• En Android: elimina tu cuenta de Google (Ajustes > Cuentas > Google > Eliminar cuenta)</div>
  <div class="text">Esto garantiza que el dispositivo no esté vinculado a tu cuenta y protege tu información personal.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Qué debo hacer antes de enviar mi dispositivo antiguo?</div>
<div class="text-box">
  <div class="text"><b>Empaquetado:</b> Usa una caja resistente y opaca (que no sea transparente),
  añade protección interna (papel burbuja o similar) para evitar daños durante el
  transporte.</div>
  <div class="text"><b>Etiqueta de envío:</b> Si no tienes material de embalaje adecuado, puedes
  solicitarlo en el punto de entrega cuando lleves tu paquete.</div>
  <div class="text"><b>Documentación:</b> Imprime, completa y firma la <b>Declaración de Honestidad</b> y
  colócala dentro del paquete antes de cerrarlo.</div>
  <div class="text"><b>Cierre seguro:</b> Asegúrate de cerrar bien el paquete y pegar la etiqueta de envío
  gratuita en un lugar visible.</div>
</div>
</div>



<div class="paragraph">
<div class="title">¿Qué tipos de dispositivos no son aceptados?</div>
<div class="text-box">
  <div class="text">No aceptamos dispositivos que:</div>
  <div class="text">• Estén bloqueados por operadora (SIM lock)</div>
  <div class="text">• No puedan encenderse</div>
  <div class="text">• Tengan cuentas de iCloud o Google aún vinculadas</div>
  <div class="text">• Sean falsificaciones o réplicas</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Debo enviar los accesorios (cargador, cable)?</div>
<div class="text-box">
  <div class="text">No es obligatorio, pero recomendable. Incluir accesorios contribuye a la
  sostenibilidad y reutilización adecuada.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Debo enviar también los auriculares?</div>
<div class="text-box">
  <div class="text">No. Por razones de higiene, los auriculares serán desechados y no se incluirán
  en la valoración.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Debo enviar la factura de compra?</div>
<div class="text-box">
  <div class="text">No es necesaria para la evaluación ni para el pago. Puedes conservarla para tus
  registros.</div>
</div>
</div>





<div class="paragraph">
<div class="title">¿Cómo evalúan mi dispositivo antiguo?</div>
<div class="text-box">
  <div class="text">Usamos software de diagnóstico certificado y realizamos una revisión manual en
  nuestro centro de inspección para evaluar el estado de tu dispositivo.
  Todo el proceso de evaluación y manejo de datos cumple con los estándares de
  <b>protección de datos del Reglamento General de Protección de Datos
  (RGPD – UE 2016/679),</b> garantizando la seguridad y confidencialidad de tu
  información.</div>
 </div>
</div>

<div class="paragraph">
<div class="title">¿Qué ocurre si el estado que indiqué no coincide con su
evaluación?</div>
<div class="text-box">
  <div class="text">Si hay diferencias entre el estado que indicaste y nuestra evaluación, te enviaremos un correo electrónico con:</div>
  <div class="text">• <b>Una oferta actualizada</b> basada en la inspección real</div>
  <div class="text">• <b>El informe de diagnóstico</b> y los motivos de la diferencia</div>
  <div class="text">Podrás elegir <b>aceptar o rechazar la oferta:</b></div>
  <div class="text">• Si aceptas, el proceso de recompra se completará y recibirás el pago en tu cuenta bancaria en un plazo de <b>3 días hábiles.</b></div>
  <div class="text">• Si rechazas, te devolveremos tu dispositivo sin coste alguno, enviándolo de vuelta en un plazo de <b>5 días hábiles</b> tras tu confirmación.</div>
 
</div>
</div>

<div class="paragraph">
<div class="title">¿Qué pasa si no respondo a la oferta actualizada?</div>
<div class="text-box">
  <div class="text">Si no respondes en <b>5 días hábiles</b>, la oferta se considerará aceptada
  automáticamente y se procesará el pago.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Qué sucede con mis datos personales?</div>
<div class="text-box">
  <div class="text">Debes borrar todos los datos antes de enviar el dispositivo antiguo.
  Si detectamos datos, pausaremos el proceso y te contactaremos para
  eliminarlos. Cumplimos con el RGPD (Reglamento UE 2016/679).</div>
</div>
</div>


<div class="paragraph">
<div class="title">¿Quién cubre los gastos de envío?</div>
<div class="text-box">
  <div class="text">El envío inicial es gratuito. Si rechazas la oferta actualizada, también cubriremos
  la devolución.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Qué ocurre si mi paquete se pierde durante el envío?</div>
<div class="text-box">
  <div class="text">Danghuan no se hace responsable de pérdidas, incluso usando nuestra etiqueta.
  Si tu paquete se pierde:</div>
  <div class="text">• Usa la etiqueta oficial y guarda el comprobante</div>
  <div class="text">• Contacta con <b>support@danghuan.eu</b></div>
  <div class="text">• Las reclamaciones pueden iniciarse tras <b>15 días naturales</b> desde el envío</div>
  <div class="text">Nota: Cualquier compensación depende de la política del transportista.</div>
 
</div>
</div>

<div class="paragraph">
<div class="title">¿Cuándo recibiré el pago?</div>
<div class="text-box">
  <div class="text">Una vez aceptada la oferta final, el pago se realizará por transferencia en <b>3 días
  hábiles.</b> Asegúrate de que tu <b>IBAN y DNI/NIE sean correctos y coincidan con
  el titular de la cuenta bancaria.</b></div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Es obligatorio introducir mi DNI o NIE?</div>
<div class="text-box">
  <div class="text">Sí, para procesar el pago es obligatorio proporcionar un <b>DNI o NIE válido</b>, sin
  espacios ni caracteres especiales, y que coincida con el titular del IBAN.</div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Puedo cancelar mi operación de Intercambio (Trade-In)?</div>
<div class="text-box">
  <div class="text">Sí, si tu dispositivo antiguo aún no ha sido pagado. Contáctanos lo antes posible
  en <b style='color: #405fff'>support@danghuan.eu</b></div>
</div>
</div>

<div class="paragraph">
<div class="title">¿Cómo cancelo una orden de Intercambio (Trade-In) ya
confirmada?</div>
<div class="text-box">
  <div class="text">Una vez que hayas <b>aceptado la oferta final y recibido el pago</b>, no es posible
  cancelar la operación ni solicitar la devolución del dispositivo, ya que este pasa a
  ser propiedad de Danghuan.</div>
  <div class="text">Si aún <b>no has aceptado la oferta</b>, contáctanos lo antes posible en
  <b style='color: #405fff'>support@danghuan.eu</b> con tu número de pedido y revisaremos tu caso.</div>
</div>
</div>
`;
